/**
 * Componente Select Archive
 * Riceve come proprietà un arrai di oggetti {id, label} la lista dei record dell'archivio
 * Gestisce il change con la proprietà onChange
 */
import React from 'react';
import { makeStyles } from '@mui/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: "100%"
    },
    selectEmpty: {
    },
}));

function labelConcat(item, properties) {
    let sortedValues = [];
    for (let i in properties) {
        sortedValues.push(item[properties[i]]);
    }
    return sortedValues.join(" - ");
}

export default function SelectComponent(props) {
    const classes = useStyles();

    // Inizializzazione del campo con scelta vuota
    const [itemId, setItemId] = React.useState((props.value) ? props.value : '');

    let itemsComponent = props.items.map((item) => 
        <MenuItem key={item.uuid} value={item.uuid}>
            {labelConcat(item, props.labelConcatProperties)}
        </MenuItem>)

    /**
     * Gestione della selezione del cabinet
     * @param {*} event
     */
    const handleChange = (event) => {
        setItemId(event.target.value);
        if (props.onChange) {
            props.onChange(event.target.value);
        }
    };
    return (
        <div style={props.style ? props.style : null}>
            <FormControl className={classes.formControl}>
                <InputLabel id="cabinet-select-label">{props.inputLabel}</InputLabel>
                <Select
                    labelId="cabinet-select-label"
                    id="cabinet-select"
                    value={itemId}
                    onChange={handleChange}
                    label={props.inputLabel}
                    disabled={props.disabled === true ? true : false}
                    fullWidth
                    className='umpi-mui-select-wrap-fixer'>
                    {itemsComponent}
                </Select>
            </FormControl>
        </div>
    );
}
